import { useContext } from "react";
import PropTypes from "prop-types";
import $ from "jquery";

import { DataContext } from "../../context/data-context";

import headerIcon from "./../../assets/location-icon-gradient.svg";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";

const RightPanelHeader = ({ isBookmark, handleBookmark }) => {
  const { clickedPointData } = useContext(DataContext);

  const title = $.isEmptyObject(clickedPointData)
    ? "استان تهران"
    : clickedPointData.data.postal_address;
  return (
    <>
      {/* <img src={headerIcon} alt="" /> */}
      <div className="header-title-name">
        <h2 className="f-Bold">{title}</h2>
        <button
          onClick={handleBookmark}
          style={{ backgroundColor: `${isBookmark ? "#fff5f5" : null}` }}
        >
          {isBookmark ? (
            <FaBookmark fontSize="1.2em" color="#C82021" />
          ) : (
            <FaRegBookmark fontSize="1.2em" color="#C82021" />
          )}
        </button>
      </div>
    </>
  );
};

RightPanelHeader.propTypes = {
  isBookmark: PropTypes.bool,
  handleBookmark: PropTypes.func,
};
RightPanelHeader.defaultProps = {
  isBookmark: false,
  handleBookmark: null,
};

export default RightPanelHeader;
